var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransactionSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 144,
    height: 144,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17251"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11564",
    d: "M72 0a72 72 0 1 0 72 72A72.08 72.08 0 0 0 72 0zm0 0",
    style: {
      opacity: 0.2,
      fill: "#0fc679"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Check",
    d: "m0 22.062 4-3.7a77.176 77.176 0 0 1 12.9 7.735C26.792 14.881 33.326 9.188 45.469 1.633l1.3 2.993C36.756 13.365 29.423 23.1 18.862 42.039A200.629 200.629 0 0 0 0 22.062z",
    transform: "translate(48.614 50.531)",
    style: {
      fill: "#0fc679"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionSuccess);
export default __webpack_public_path__ + "static/media/TransactionSuccess.6818ecee.svg";
export { ForwardRef as ReactComponent };